import {
  ECustomerReportSettingPeriodType,
  ECustomerReportSettingType,
} from '@/enums/ECustomerRerportSetting';

const getCustomerReportSettingTypeName = (
  status: ECustomerReportSettingType,
): string => {
  switch (status) {
    case ECustomerReportSettingType.EVERYDAY:
      return 'EVERY DAY';
    case ECustomerReportSettingType.EVERYWEEK:
      return 'EVERY WEEK';
  }
};

const getCustomerReportSettingPeriodTypeName = (
  status: ECustomerReportSettingPeriodType,
): string => {
  switch (status) {
    case ECustomerReportSettingPeriodType.WEEKLY:
      return 'WEEKLY';
    case ECustomerReportSettingPeriodType.MONTH_TO_DATE:
      return 'MONTH TO D.';
  }
};

export {
  getCustomerReportSettingTypeName,
  getCustomerReportSettingPeriodTypeName,
};
